<template>
  <b-modal ref="deleteConfirmation" :id=modalId :title="deleteDisplayName">
      {{deletePrompt}}
      <div slot="modal-footer">
        <b-button variant="danger" class="button-row-spacing" @click="hideModal">
          No
        </b-button>
        <b-button @click="onDeleteConfirmed()">
          Yes
        </b-button>
      </div>
    </b-modal>
</template>
<script>
export default {
  name: 'DeleteModal',
  components: {
  },
  props: {
    modalId: String,
    deletePrompt: {
      type: String,
      default() {
        return 'Are you sure you want to delete?';
      },
    },
    deleteDisplayName: {
      type: String,
      default() {
        return 'Delete';
      },
    },
  },
  methods: {
    hideModal() {
      this.$refs.deleteConfirmation.hide();
    },
    onDeleteConfirmed() {
      this.$refs.deleteConfirmation.hide();
      this.$emit('deleteConfirmed');
    },
  },
};
</script>
